import { all, fork } from 'redux-saga/effects';
import watchUser from './UserSaga';

export default function* () {
  yield all([fork(watchUser)]);
}
